import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import PillList from '../PillList'

const propTypes = {
  /**
   * Options of the SwapList.
   * Similar to the options passed to react-select
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ),
  /**
   * Values selected from the options
   */
  value: PropTypes.arrayOf(PropTypes.string),
  /**
   * Callback called when an option is added or removed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Top label, of the selected values. Formatted message id
   */
  selectedOptionsTitle: PropTypes.string.isRequired,
  /**
   * Bottom label, of the unselected values. Formatted message id
   */
  unselectedOptionsTitle: PropTypes.string.isRequired,
  /**
   * id of the SwapList
   */
  id: PropTypes.string,
  /**
   * If true, presents a loading animation
   */
  loading: PropTypes.bool,
  /**
   * If true, shows unselected section first
   */
  reverse: PropTypes.bool,
  /**
   * Limit the number of items being shown.
   * If passed will show a 'show more' button to toggle the visibility of the excess items
   */
  maxItems: PropTypes.number,
}

/**
 * Shows both selected (top) and unselected values (bottom) given an array of option
 * Allows swaping the values from one list to the other
 */
function SwapList(props) {
  const {
    options = [],
    value = [],
    onChange,
    selectedOptionsTitle,
    unselectedOptionsTitle,
    id = '',
    loading = false,
    reverse = false,
    maxItems = undefined,
  } = props ?? {}

  const removeValue = (valueToRemove) => {
    const newValue = value.filter((val) => val !== valueToRemove)
    onChange(newValue)
  }

  const addValue = (valueToAdd) => {
    onChange([...value, valueToAdd])
  }

  const selected = options.filter((option) => value.includes(option.value))

  const unselected = options.filter((option) => !value.includes(option.value))

  const selectedSection = (
    <div className="mb-2">
      <div className="mb-2">
        <FormattedMessage id={selectedOptionsTitle} />
      </div>
      <div id={`${id}-selected`}>
        <PillList items={selected} onRemoval={removeValue} loading={loading} maxItems={maxItems} />
      </div>
    </div>
  )

  const unselectedSection = (
    <div className="mb-2">
      <div className="mb-2">
        <FormattedMessage id={unselectedOptionsTitle} />
      </div>
      <div id={`${id}-unselected`}>
        <PillList items={unselected} onRemoval={addValue} loading={loading} maxItems={maxItems} />
      </div>
    </div>
  )

  return (
    <div id={id}>
      {reverse ? (
        <>
          {unselectedSection}
          {selectedSection}
        </>
      ) : (
        <>
          {selectedSection}
          {unselectedSection}
        </>
      )}
    </div>
  )
}

SwapList.propTypes = propTypes

export default SwapList
